import React from 'react';
import { ResponsiveAppBar } from '../../components/ResponsiveAppBar';
import Footer from '../../components/Footer';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Helmet } from 'react-helmet-async';
import Panel from '../../components/Panel';
import { lightTheme } from '../../customTheme';
import { useAuth } from '../../contexts/AuthContext';
import SignInCard from '../../components/SignInCard';
import PATHS from '../../utils/paths';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import { useNavigate, useSearchParams } from 'react-router-dom';

const SignIn = () => {
  const { isSignedIn } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const fromPricing = searchParams.get('from') === 'pricing';

  React.useEffect(() => {
    if (isSignedIn) {
      if (fromPricing) {
        navigate(PATHS.PRICING);
      } else {
        navigate(PATHS.PRODUCT_RESEARCH);
      }
    }
  }, [isSignedIn, navigate, fromPricing]);

  return (
    <div style={{ position: 'relative' }}>
      {!isSignedIn && <>
        <Helmet >
          <title>Create your Account</title>
          <meta name="description" content={"Create an account on Poshwatch"} />
        </Helmet>
        <ResponsiveAppBar hideLinks />
        <Panel theme={lightTheme}>
          <Container maxWidth='sm' style={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }}>
            <Card style={{ minWidth: "400px" }} variant="outlined">
              <CardContent style={{ padding: "30px" }}>
                <Typography variant="h4" fontFamily={"Libre Baskerville"}>
                  Create your Account
                </Typography>
                <Typography variant="body1" paddingTop={2} paddingBottom={4} >
                  To access additional features.
                </Typography>
                <SignInCard register={true} />
                <Box paddingBottom={2} paddingTop={2}>
                  <Divider />
                </Box>
                <Button
                  onClick={
                    () => {
                      navigate(PATHS.SIGN_IN);
                    }
                  }
                  variant="text"
                  color="primary"
                  fullWidth
                  style={{ textTransform: 'none', textDecoration: 'underline' }}
                >
                  Already have an account? Sign In
                </Button>
              </CardContent>
            </Card>
          </Container>
        </Panel>
        <Footer hideLinks />
      </>}
    </div>
  );
};

export default SignIn;